import { render, staticRenderFns } from "./wizard-step3.vue?vue&type=template&id=25f808e6"
import script from "./wizard-step3.vue?vue&type=script&lang=js"
export * from "./wizard-step3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports